import { createPluginRegistry } from '@ff-os/shared-utils/createPluginRegistry';
import { Variable } from './Variable';

export const variablePlugins = createPluginRegistry<Variable.Plugin<any, any>>();